import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';

export const DispatchTagsDialog = ({ order, status, onClose, onSubmit }) => {
  const missing = (order?.tags_needed || 0) - (order?.assigned_tag_ids?.length || 0);
  const [ids, setIds] = useState([]);
  const [busy, setBusy] = useState(false);
  const setAt = (i, v) => { const n = [...ids]; n[i] = v.toUpperCase(); setIds(n); };
  const ready = Array.from({ length: missing }).every((_, i) => (ids[i] || '').trim());
  const submit = async () => { setBusy(true); try { await onSubmit(ids.slice(0, missing)); } finally { setBusy(false); } };

  return (
    <Dialog open={!!order} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="dispatch-tags-dialog">
        <DialogHeader>
          <DialogTitle>Assign printed tags · {order?.order_number}</DialogTitle>
          <DialogDescription>
            Enter {missing} tag number(s) to mark this order {status}. Pack {order?.stickers} printed sticker(s).
          </DialogDescription>
        </DialogHeader>
        {order?.assigned_tag_ids?.length > 0 && <p className="text-xs text-neutral-500">Already assigned: {order.assigned_tag_ids.join(', ')}</p>}
        <div className="space-y-2">
          {Array.from({ length: missing }).map((_, i) => (
            <input key={i} value={ids[i] || ''} onChange={(e) => setAt(i, e.target.value)} placeholder={`Tag number ${i + 1} (e.g. TAG0022 or 22)`} className="w-full px-3 py-2 rounded-lg border border-black/15 font-mono text-sm" data-testid={`dispatch-tag-input-${i}`} />
          ))}
        </div>
        <div className="flex justify-end gap-2 mt-2">
          <button onClick={onClose} className="btn-outline text-sm" data-testid="dispatch-tags-cancel">Cancel</button>
          <button onClick={submit} disabled={!ready || busy} className="btn-primary text-sm disabled:opacity-60" data-testid="dispatch-tags-submit">{busy ? 'Saving…' : `Assign & mark ${status}`}</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
